/* 1) Bloc cadeaux : meme mise en page que Miroclean. On relit les cadeaux de l'app Rapid Bundle (nom, verrou, valeur, image)
      et on les affiche dans notre bloc, place juste sous les offres. Le bloc de l'app reste dans la page mais cache.
   2) Garde-fou : un cadeau ne doit jamais rester dans le panier a plein prix. */
(function () {
  var GIFTS = ['viskina-mini-mikrofiberklud', 'viskina-mikrofiberhandske', 'viskina-e-bog-hvorfor-det-giver-striber'];
  var LOCK = '<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M44.584 21H42.834V14C42.834 6.279 36.555 0 28.834 0C21.113 0 14.834 6.279 14.834 14V21H13.084C10.1907 21 7.83398 23.3543 7.83398 26.25V50.75C7.83398 53.6457 10.1907 56 13.084 56H44.584C47.4773 56 49.834 53.6457 49.834 50.75V26.25C49.834 23.3543 47.4773 21 44.584 21ZM19.5007 14C19.5007 8.85267 23.6867 4.66667 28.834 4.66667C33.9813 4.66667 38.1673 8.85267 38.1673 14V21H19.5007V14ZM31.1673 39.018V44.3333C31.1673 45.6213 30.1243 46.6667 28.834 46.6667C27.5436 46.6667 26.5007 45.6213 26.5007 44.3333V39.018C25.1123 38.2083 24.1673 36.7197 24.1673 35C24.1673 32.4263 26.2603 30.3333 28.834 30.3333C31.4076 30.3333 33.5007 32.4263 33.5007 35C33.5007 36.7197 32.5557 38.2083 31.1673 39.018Z" fill="currentColor" transform="translate(21.5, 22)"/></svg>';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(n) {
    return n.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
  }
  function parseMoney(t) {
    var s = String(t || '').replace(/[^0-9,.]/g, '').replace(/\./g, '').replace(',', '.');
    return parseFloat(s) || 0;
  }

  function readTiles(booster) {
    return [].slice.call(booster.querySelectorAll('.rapi-each-goal-block')).map(function (b) {
      var nameEl = b.querySelector('.rapi-progress-reward-text');
      var name = ((nameEl && nameEl.textContent) || '').replace(/\s+/g, ' ').trim();
      var del = b.querySelector('.rapi-progressbar-gift-highlight-text del');
      var unit = parseMoney(del && del.textContent);
      var m = name.match(/^(\d+)\s*x\s+/i);
      var qty = m ? parseInt(m[1], 10) : 1;
      var img = b.querySelector('img');
      return {
        name: name,
        locked: !!b.querySelector('.rapi-lock'),
        value: unit * qty,
        img: img ? img.currentSrc || img.getAttribute('src') || '' : ''
      };
    });
  }

  function tileHtml(t) {
    var media = t.locked
      ? LOCK
      : t.img
      ? '<img src="' + esc(t.img) + '" alt="" class="' + (/mini-paire/.test(t.img) ? 'is-white' : '') + '">'
      : '';
    var val = !t.locked && t.value > 0 ? '<br><s class="vkg-val">' + money(t.value) + '</s>' : '';
    return (
      '<div class="vkg-tile ' + (t.locked ? 'is-locked' : 'is-open') + '">' +
      '<span class="vkg-badge">Gratis</span>' +
      '<div class="vkg-img">' + media + '</div>' +
      '<div class="vkg-name"><strong>' + esc(t.name) + '</strong>' + val + '</div>' +
      '</div>'
    );
  }

  function render() {
    var booster = document.querySelector('.rapi-bundle-boosters-afteratc-0');
    var offers = document.querySelector('.rapi-bundle-content-0');
    if (!booster || !offers || !offers.parentNode) return;
    var tiles = readTiles(booster);
    if (!tiles.length) return;
    var host = document.getElementById('vk-gifts');
    if (!host) {
      host = document.createElement('div');
      host.id = 'vk-gifts';
    }
    if (offers.nextElementSibling !== host) offers.parentNode.insertBefore(host, offers.nextSibling);
    var total = tiles.reduce(function (s, t) { return s + t.value; }, 0);
    var html =
      '<div class="vkg-head"><div class="vkg-title">🎁 Eksklusive gaver med Deres ordre</div>' +
      (total > 0 ? '<div class="vkg-sub">Op til <strong>' + money(total) + '</strong> i gaver inkluderet!</div>' : '') +
      '</div><div class="vkg-grid">' + tiles.map(tileHtml).join('') + '</div>';
    if (host.getAttribute('data-sig') !== html) {
      host.innerHTML = html;
      host.setAttribute('data-sig', html);
    }
  }

  /* ---------- garde-fou panier ---------- */
  var busy = false;
  var timer = null;
  function nf(url, opts) {
    return (window.nvNativeFetch || window.fetch)(url, opts);
  }
  function paidGifts(cart) {
    return cart.items.filter(function (i) {
      return GIFTS.indexOf(i.handle) > -1 && i.final_line_price > 0;
    });
  }
  function getCart() {
    return nf('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function guard() {
    if (busy) return;
    busy = true;
    getCart()
      .then(function (cart) {
        if (!paidGifts(cart).length) { busy = false; return; }
        return new Promise(function (res) { setTimeout(res, 1500); })
          .then(getCart)
          .then(function (c2) {
            var bad = paidGifts(c2);
            var chain = Promise.resolve();
            bad.forEach(function (i) {
              chain = chain.then(function () {
                return nf('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ id: i.key, quantity: 0 })
                });
              });
            });
            return chain.then(function () {
              if (bad.length && window.nvRefreshCart) return window.nvRefreshCart(false);
            });
          })
          .then(function () { busy = false; });
      })
      .catch(function () { busy = false; });
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(guard, 900);
  }
  function watchCart() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) new MutationObserver(schedule).observe(drawer, { childList: true });
    var page = document.querySelector('[data-cart-page]');
    if (page) new MutationObserver(schedule).observe(page, { childList: true });
    schedule();
  }

  function start() {
    watchCart();
    var product = document.querySelector('#product');
    if (!product) return;
    render();
    var tries = 0;
    var t = setInterval(function () { render(); if (++tries > 60) clearInterval(t); }, 500);
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(render, 120);
    }).observe(product, { childList: true, subtree: true, attributes: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
